import styled from "styled-components";

export const WarrantyText = styled.p`
    font-size: 12px;
    line-height: 18px;
`;

export const WarrantyMail = styled.a`
    text-decoration: underline;
`;